import React from 'react';
import AddToFavourites from './AddToFavourites';

const MenuTabs = ({
  drawingId,
  breadcrumbs,
  threeDEnabled,
  layoutsEnabled,
  quoteBuilderV2Enabled,
  quoteBuilderEnabled,
  threeDPath,
  layoutsLandingPath,
  manufacturingCostCalculatorV2Path,
  dielinesApiDrawingTabPath,
  dielinesPath,
  noBookmark = false,
  activeTab = null,
  advancedOptionsFormVisible = false,
  rawArguments = null,
  onNavigate = null
}) => {

  // Common helper to check if navigation should be blocked
  const checkNavigationBlocked = (e, requireLogin = true) => {
    const target = e.currentTarget;

    // Check if tab is disabled
    if (target.classList.contains("disabledMenuTab")) {
      return true;
    }

    // Check if user is logged in (if login is required)
    if (requireLogin && !window.loggedIn) {
      if (typeof emitLogInRequired === 'function') {
        emitLogInRequired();
      }
      return true;
    }

    // Check if menu tabs are disabled
    if (window.menu_tabs_disabled) {
      if (typeof trackEvent === 'function') {
        trackEvent('menu_tabs_denied');
      }
      // Trigger redraw button click if it exists
      const redrawBtn = document.getElementById('redraw_btn');
      if (redrawBtn) {
        redrawBtn.click();
      }
      return true;
    }

    return false;
  };

  // Helper to navigate with dieline options
  const navigateWithDielineOptions = (action) => {
    // Clean up form inputs
    const authTokens = document.querySelectorAll('input[name$="authenticity_token"]');
    const fileNames = document.querySelectorAll('input[name$="file_name"]');
    const downloadNotes = document.querySelectorAll('input[name$="download_notes"]');

    authTokens.forEach(el => el.remove());
    fileNames.forEach(el => el.remove());
    downloadNotes.forEach(el => el.remove());

    const downloadForm = document.getElementById('download_form_dxf');

    if (!downloadForm) {
      const requestPath = window.get_request_path?.().split("?")[1];
      window.location.href = action + '/' + btoa(requestPath || '') + `?advanced_options_enabled=${advancedOptionsFormVisible}`;
    } else {
      // Serialize form data
      const formData = new FormData(downloadForm);
      const params = new URLSearchParams(formData).toString();
      window.location.href = action + '/' + btoa(params) + `?advanced_options_enabled=${advancedOptionsFormVisible}`;
    }
  };

  // Helper to navigate with raw arguments
  const navigateWithRawArguments = (action) => {
    window.location.href = action + '/' + (rawArguments || window.rawArguments || '');
  };

  // Handler for breadcrumbs tab
  const handleBreadcrumbsClick = (e) => {
    e.preventDefault();

    // Don't navigate if already on breadcrumbs or no path available
    if (activeTab === 'breadcrumbs' || !dielinesPath) {
      return;
    }

    // Always require login for tab navigation
    if (checkNavigationBlocked(e, true)) {
      return;
    }

    // Custom navigation handler if provided
    if (onNavigate) {
      const submit = activeTab === 'dielines_api' ? 'direct' : 'dieline-options-from-layout';
      onNavigate(dielinesPath, submit, advancedOptionsFormVisible);
      return;
    }

    // Navigate based on where we're coming from
    if (activeTab === 'dielines_api') {
      window.location.href = dielinesPath;
    } else if (activeTab === 'layouts') {
      navigateWithRawArguments(dielinesPath);
    } else {
      window.location.href = dielinesPath;
    }
  };

  // Handler for 3D Mockup tab
  const handle3DClick = (e) => {
    e.preventDefault();

    const action = e.currentTarget.dataset.action || threeDPath;

    if (!action || checkNavigationBlocked(e, true)) {
      return;
    }

    // Custom navigation handler if provided
    if (onNavigate) {
      const submitType = activeTab === 'dielines_api' ? 'dieline-options-from-api' : 'dieline-options';
      onNavigate(action, submitType, advancedOptionsFormVisible);
      return;
    }

    // Navigate based on current page
    if (activeTab === 'dielines_api' || activeTab === 'layouts') {
      navigateWithRawArguments(action);
    } else {
      navigateWithDielineOptions(action);
    }
  };

  // Handler for Layouts/Nesting tab
  const handleLayoutsClick = (e) => {
    e.preventDefault();

    const action = e.currentTarget.dataset.action || layoutsLandingPath;

    if (!action || activeTab === 'layouts' || checkNavigationBlocked(e, true)) {
      return;
    }

    // Custom navigation handler if provided
    if (onNavigate) {
      const submitType = activeTab === 'dielines_api' ? 'dieline-options-from-api' : 'dieline-options';
      onNavigate(action, submitType, advancedOptionsFormVisible);
      return;
    }

    // Navigate based on current page
    if (activeTab === 'dielines_api') {
      navigateWithRawArguments(action);
    } else {
      navigateWithDielineOptions(action);
    }
  };

  // Handler for Quote Builder V2 tab
  const handleQuoteBuilderV2Click = (e) => {
    e.preventDefault();

    const action = e.currentTarget.dataset.action || manufacturingCostCalculatorV2Path;

    if (!action || checkNavigationBlocked(e, true)) {
      return;
    }

    // Custom navigation handler if provided
    if (onNavigate) {
      onNavigate(action, 'dieline-options', advancedOptionsFormVisible);
      return;
    }

    // Always navigate with dieline options
    navigateWithDielineOptions(action);
  };

  // Handler for Dielines API tab
  const handleDielinesApiClick = (e) => {
    e.preventDefault();

    const action = e.currentTarget.dataset.action || dielinesApiDrawingTabPath;

    if (!action || activeTab === 'dielines_api') {
      return;
    }

    // Always require login for tab navigation
    if (checkNavigationBlocked(e, true)) {
      return;
    }

    // Custom navigation handler if provided
    if (onNavigate) {
      onNavigate(action, 'dieline-options', advancedOptionsFormVisible);
      return;
    }

    // Navigate with dieline options from any page
    navigateWithDielineOptions(action);
  };

  const getTabClassName = (tabName) => {
    const baseClass = 'shortcode_tab_item_title';
    const isActive = activeTab === tabName;
    return `${baseClass} ${isActive ? 'inactivetab' : 'active'}`;
  };

  return (
    <div className="container" id="menuTabs">
      <div className="row" style={{ borderLeft: '1px solid #eee' }}>
        <div className="col-lg-12" style={{ marginLeft: '-15px', marginBottom: '15px' }}>
          <div className="all_heads_cont">

            {!noBookmark && (
              <AddToFavourites defaultId={drawingId} />
            )}

            <div
              className={`shortcode_tab_item_title ${activeTab === 'breadcrumbs' ? 'inactivetab largeText16' : 'active'}`}
              style={{ borderLeft: '0px solid #eee', marginTop: '0px' }}
              onClick={handleBreadcrumbsClick}
            >
              <span id="header_breadcrumbs">{breadcrumbs}</span>
            </div>

            {threeDEnabled && (
              <div
                className={getTabClassName('3d')}
                id="menu_tab_3d"
                style={{ marginTop: '0px' }}
                onClick={handle3DClick}
              >
                {t('three_d.three_d_view')}
              </div>
            )}

            {layoutsEnabled && (
              <div
                className={getTabClassName('layouts')}
                id="menu_tab_nesting"
                style={{ marginTop: '0px' }}
                onClick={handleLayoutsClick}
              >
                {quoteBuilderEnabled
                  ? t('layouts.layouts_and_quote_builder_view')
                  : t('layouts.layouts_view')
                }
              </div>
            )}

            {quoteBuilderV2Enabled && (
              <div
                className={getTabClassName('quote_builder_v2')}
                id="menu_tab_nesting_v2"
                style={{ marginTop: '0px' }}
                onClick={handleQuoteBuilderV2Click}
              >
                Manufacturing Cost Calculator (V2)
              </div>
            )}

            <div
              className={`shortcode_tab_item_title ${activeTab === 'dielines_api' ? 'inactive largeText16' : 'active'}`}
              id="menu_tab_dielines_api"
              style={{ marginTop: '0px' }}
              onClick={handleDielinesApiClick}
            >
              {t('nav.dielines_api_for_developers')}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuTabs;